<template>
    <v-card class="elevation-12" style="border-radius: 15px">
      <v-toolbar dark class="gradient">
        <v-toolbar-title>
          <v-icon>person</v-icon>
          Bem Vindo
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn small color="indigo" dark round outline href="#/register">
          Registrar
        </v-btn> -->
      </v-toolbar>
      <v-card-text>
        <div class="top">
          <img src="static/img/logo.png" height="150px" class="" alt="Logomarca">
        </div>

        <div class="body">
          <v-form >
            <v-container grid-list-lg fluid>
              <v-layout row justify-center align-center wrap>
                <v-flex xs12>
                  <v-text-field prepend-icon="person" name="login" label="Login" type="text" autofocus
                                v-model="user.email" v-on:keydown.enter="login"/>
                </v-flex>
                <v-flex xs12>
                  <v-text-field prepend-icon="lock" name="password" label="Password" id="password"
                                type="password" v-model="user.password" v-on:keydown.enter="login"/>
                </v-flex>
                <!-- <v-flex xs12>
                  <v-checkbox label="Lembrar minha senha" v-model="rememberMe"/>
                </v-flex> -->
                <v-flex xs12 class="text-xs-center">
                  <v-btn @click="login()" :loading="loading" dark class="gradient">
                    Entrar
                  </v-btn>
                  <!-- <v-btn flat href="#/forgot">Esqueci minha senha</v-btn> -->
                </v-flex>
                <!--<v-flex xs12>-->
                  <!--<hr class="my-3">-->
                <!--</v-flex>-->
                <!--<v-flex class="text-xs-center">-->
                  <!--<v-btn flat icon color="indigo">-->
                    <!--<v-icon>fab fa-facebook</v-icon>-->
                  <!--</v-btn>-->
                  <!--<v-btn flat icon color="teal darken-2">-->
                    <!--<img height="24px" src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/512px-Google_%22G%22_Logo.svg.png"/>-->
                  <!--</v-btn>-->
                  <!--<v-btn flat icon color="blue">-->
                    <!--<v-icon>fab fa-twitter</v-icon>-->
                  <!--</v-btn>-->
                <!--</v-flex>-->
              </v-layout>
            </v-container>
          </v-form>
        </div>
      </v-card-text>
    </v-card>
</template>

<style scoped>
  .top {
    display: flex;
    justify-content: center;
  }
  .gradient {
    background: linear-gradient(40deg, #11998e, #38ef7d);
  }
</style>

<script>
  import Card from '../shared/Card'

  export default {
    components: {Card},
    data () {
      return {
        user: {
          email: '',
          password: ''
        },
        rememberMe: false,
        loading: false
      }
    },
    methods: {
      login () {
        this.loading = true
        this.$auth.login({
          body: this.user,
          fetchUser: true,
          rememberMe: this.rememberMe,
          success: function (res) {
            this.loading = false
          },
          error: function (res) {
            alert('Ocorreu algum problema no login! Favor Confira os dados!')
            this.loading = false
          },
          redirect: '/home'
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/Login.vue